import React from 'react';
import './styles.css';

const Footer = () => {
  return (
    <>
    <div className='footer-position'>
      <footer className="footer">
        <div className="footer-container">
          <div className='footer-details2'>
            <div className="footer-contact">
              <h3>Contact</h3>
              <p className='footer-home-li'>Email: <a href="mailto:khaledjafarmoh@gmail.com" target="_blank" rel="noopener noreferrer">khaledjafarmoh@gmail.com</a></p>          
              <p className='footer-home-li'>LinkedIn: <a href="https://www.linkedin.com/in/khaled-jafar-abu-ijdea-a-547483274/" target="_blank" rel="noopener noreferrer">linkedin.com/in/khaledjafar</a></p>
              <p className='footer-home-li'>GitHub: <a href="https://github.com/khaledjafar" target="_blank" rel="noopener noreferrer">github.com/khaledjafar</a></p>
              {/* <p className='aboutme-text1'>GitHub project link will be provided upon request.</p> */}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className='footer-bottom-line'>
            <p className='p-©'>© {new Date().getFullYear()} Khaled Jafar. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default Footer;
